import { LambdaSchema } from "./types";

const schema: LambdaSchema = {
  columns: [
    { key: "summarize_job_name", label: "summarize_job_name" },
    { key: "llm_calls", label: "llm_calls" },
    { key: "e_and_m_code", label: "e_and_m_code" },
    { key: "visit_type", label: "visit_type" }
  ],
};

export default schema;

